import { FC, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Result, Button, Typography } from "antd";

const OAuthError: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState<string>("Authentication failed");
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const message = params.get("message");
    if (message) {
      setErrorMessage(message);
    }
  }, [location]);
  
  return (
    <Result
      status="error"
      title="Authentication Failed"
      subTitle={errorMessage}
      extra={[
        <Button type="primary" key="signin" onClick={() => navigate("/sign-in")}>
          Go to Sign In
        </Button>,
      ]}
    />
  );
};

export default OAuthError; 